export default __webpack_public_path__ + "static/media/kitchen.3d1453c0.webp";